module.exports = __webpack_public_path__ + "media/svg-new/avatar-20 3-19e59939.svg";